"use client"

import { useEffect, useState, useCallback, useRef } from "react"
import "./SessionTimeout.css"
import { useNavigate } from "react-router-dom"
import useUserStore from "../store/useUserStore"
import { useMsal } from "@azure/msal-react";


const IDLE_TIMEOUT = 30* 60 * 1000 // 30 minutes in milliseconds
const WARNING_TIME = 1 * 60 * 1000 // Show warning 2 minutes before logout

export default function SessionTimeout() {
  const navigate = useNavigate()
  const { isAuthenticated, lastActivity, logout, updateLastActivity,isRecordingStarted } = useUserStore()
  const [showWarning, setShowWarning] = useState(false)
  const [timeLeft, setTimeLeft] = useState(0)
  const intervalRef = useRef(null)
  const {instance, accounts } = useMsal();


  // Function to reset user activity timestamp
  const resetTimer = useCallback(() => {
    updateLastActivity() // Only call on user interaction
  }, [updateLastActivity])

  // Function to check timeout
  const checkTimeout = useCallback(() => {
    if (!lastActivity || !isAuthenticated) return
    const now = new Date().getTime()
    const lastActivityTime = new Date(lastActivity).getTime()
    const timeSinceLastActivity = now - lastActivityTime
    // console.log(timeSinceLastActivity/1000)
    // console.log(isRecordingStarted, "Before")
    if(isRecordingStarted){
      resetTimer()
      setShowWarning(false)
    }
    else if (timeSinceLastActivity >= IDLE_TIMEOUT) {
      handleLogout()
    } else if (timeSinceLastActivity >= IDLE_TIMEOUT - WARNING_TIME) {
      setShowWarning(true)
      setTimeLeft(Math.ceil((IDLE_TIMEOUT - timeSinceLastActivity) / 1000))
    }
  }, [lastActivity, isAuthenticated,isRecordingStarted])


  useEffect(() => {
    if (!isAuthenticated) return
    const events = ["mousedown", "mousemove", "keypress", "scroll", "touchstart"]
    const handleActivity = () => {
      resetTimer()
      setShowWarning(false)
    }

    events.forEach((event) => {
      document.addEventListener(event, handleActivity)
    })

    // Clear previous interval to prevent multiple timers
    if (intervalRef.current) clearInterval(intervalRef.current)

    // Check timeout every second
    intervalRef.current = setInterval(checkTimeout, 1000)

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, handleActivity)
      })
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [isAuthenticated, checkTimeout])

  const handleStayLoggedIn = () => {
    resetTimer()
    setShowWarning(false)
  }

  const handleLogout = async() => {
    setShowWarning(false)
    const currentAccount = instance.getAccountByHomeId(accounts[0]?.homeAccountId);
    logout()
    // navigate("/")
    // // await instance.logoutRedirect({ account: currentAccount});
    // instance.logoutPopup({
    //   postLogoutRedirectUri: "http://localhost:3000"
    // });
    await instance.clearCache();
    window.location.href = "/"
  }

  if (!showWarning) return null

  return (
    <div className="timeout-overlay">
      <div className="timeout-modal">
        <h2>Session Timeout Warning</h2>
        <p>Your session will expire in {timeLeft} seconds due to inactivity.</p>
        <div className="timeout-actions">
          <button className="stay-button" onClick={handleStayLoggedIn}>
            Stay Logged In
          </button>
          <button className="logout-button" onClick={handleLogout}>
            Logout Now
          </button>
        </div>
      </div>
    </div>
  )
}
